/**
 * @name Carousel
 * @description Componente de imágenes en un carrusel
 * @author César Rivera
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Carousel Material-UI
import MuiCarousel from 'react-material-ui-carousel';

const Carousel = ({ items }) => {
  return (
    <StyledCarousel
      indicators={true}
      animation="fade"
    >
      {items.map((item, index) => (
        <div key={index} style={{ height: '430px' }}>
          <CarouselImg url={item.URL} />
        </div>
      ))}
    </StyledCarousel>
  );
};

Carousel.propTypes = {
  // URL de las imagenes del carrusel.
  items: PropTypes.array
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const CarouselImg = styled.div`
  height: 100%;
  /*width: 100%;*/
  background-image: url(${(props) => props.url});
  background-size: contain;
  background-position: center;
  border-radius: 6px;
  background-repeat: no-repeat;
`;

const StyledCarousel = styled(MuiCarousel)`
  height: 432px;
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.depth3};

  .Carousel-indicators-4 {
    margin-top: -25px;
  }

  .Carousel-indicators-14 {
    margin-top: -25px;
  }
`;

export default Carousel;